import React from "react";
import { Collapse, Row, Col, Checkbox } from "antd";
import { observer } from "mobx-react";
// import axios from "axios";
import { getSnapshot } from "mobx-state-tree";
const Panel = Collapse.Panel;

// 男性から女性へのシカケテガミ
import Information from "../components/steps/Informations.js"; //step-1
import FaceSelection from "../components/steps/FaceSelection.js"; //step-2
import StorySelection from "../components/steps/StorySelection.js"; //step-3
import CustomMessage from "../components/steps/CustomMessage.js"; //step-4
import Panflet from "../components/steps/Panflet.js"; //step-5

// 親から子へのシカケテガミ用
import InformationParentToChild from "../components/steps/InformationsParentToChild.js"; //step-1
import FaceSelectionParentToChild from "../components/steps/FaceSelectionParentToChild.js"; //step-2
import StorySelectionParentToChild from "../components/steps/StorySelectionParentToChild.js"; //step-3
import CustomMessageParentToChild from "../components/steps/CustomMessageParentToChild.js"; //step-4
import PanfletParentToChild from "../components/steps/PanfletParentToChild.js"; //step-5

// 女性から男性へのシカケテガミ用
import InformationFemaleToMale from "../components/steps/InformationsFemaleToMale.js"; //step-1
import FaceSelectionFemaleToMale from "../components/steps/FaceSelectionFemaleToMale.js"; //step-2
import StorySelectionFemaleToMale from "../components/steps/StorySelectionFemaleToMale.js"; //step-3
import CustomMessageFemaleToMale from "../components/steps/CustomMessageFemaleToMale.js"; //step-4
import PanfletFemaleToMale from "../components/steps/PanfletFemaleToMale.js"; //step-5

// 子から親へのシカケテガミ用
import InformationChildToParent from "../components/steps/InformationsChildToParent.js"; //step-1
import FaceSelectionChildToParent from "../components/steps/FaceSelectionChildToParent.js"; //step-2
import StorySelectionChildToParent from "../components/steps/StorySelectionChildToParent.js"; //step-3
import CustomMessageChildToParent from "../components/steps/CustomMessageChildToParent.js"; //step-4
import PanfletChildToParent from "../components/steps/PanfletChildToParent.js"; //step-5

import Title from "../components/steps/Title";
import { productTypeMap } from "../utils/";

const isObject = v => {
  return v && typeof v === "object" && v.constructor === Object;
};

const parseElement = (e, name, key) => {
  if (Array.isArray(e)) {
    return parseArray(e, name, key);
  } else {
    if (isObject(e)) {
      return parseObject(e, name, key);
    } else {
      let value = e || "";
      return <input key={key} id={name} name={name} type="hidden" value={value} />;
    }
  }
};

const parseObject = (o, p, k) => {
  return Object.keys(o).map((key, i) =>
    parseElement(o[key], p ? `${p}[${key}]` : `${key}`, `${k}${i}`)
  );
};

const parseArray = (a, p, k) =>
  a.map((v, i) => parseElement(v, `${p}[]`, `${k}${i}`));

const parseBook = d => {
  return parseObject(d);
};

const Variants = variantsList => {
  const variants = [];

  variantsList.forEach((v, key) => {
    variants.push(
      <option key={key} value={v.id}>
        {v.title}
      </option>
    );
  });

  return (
    <select
      name="id"
      className="product-form__variants no-js"
      defaultValue={0}
    >
      {variants}
    </select>
  );
};

class Order extends React.Component {
  state = {
    isConfirm: false,
    submitting: false
  };

  handleConfirmChange = e => {
    const isConfirm = !this.state.isConfirm;
    this.setState({ isConfirm: isConfirm });
  }

  handleSubmit = e => {
    e.preventDefault();
    this.setState({ submitting: true });
    const { id, ...data } = getSnapshot(this.props.order.book);
    const formData = new FormData(e.target);
    const productType = productTypeMap[data.productType];

    let bookId = id;

    // productTypeが増えると分岐も増える
    if (productType === "parent_to_child") {
      bookId = data.parentToChild.id;
    } else if (productType === "child_to_parent") {
      bookId = data.childToParent.id;
    }
    data.bookId = bookId;
    // console.log({data});
    const isProd = process.env.REACT_APP_SHOPIFY_ADDR === "https://shikaketegami.com";
    // bridalが空かどうかチェック
    const hasBridalKey = data.bridal && typeof data.bridal === 'object' && data.bridal.key && data.bridal.key.trim() !== "";

    // 空のbridalオブジェクトを削除
    if (!hasBridalKey && data.bridal) {
      delete data.bridal;
    }

    const apiUrl = hasBridalKey
      ? `${process.env.REACT_APP_BRIDAL_API_ADDR}/book/${bookId}/` : `${process.env.REACT_APP_API_ADDR}/book/${bookId}/`;


    fetch(apiUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(data)
    })
      .then(res => {
        if (!res.ok) {
          throw new Error("Network response was not ok");
        }
        return res.arrayBuffer();
      })
      .then(buffer => {
        if (this.props.isInCart) {
          // カート更新時
          const cartAttributes = {
            id: bookId
          };

          if (hasBridalKey) {
            cartAttributes.bridal = 'bridal';
          }

          fetch("/cart/update.js", {
            method: "POST",
            credentials: 'same-origin',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              attributes: cartAttributes
            }),
          }).then(res => {
            console.log({ res });
            window.location.href = `${process.env.REACT_APP_SHOPIFY_ADDR}/cart`;
            this.setState({ submitting: false });
          });
        } else {
          // カート追加時
          const itemData = {
            items: [{
              id: formData.get('id'),
              quantity: 1,
              // properties: {
              //   '_id': bookId
              // }
            }],
            attributes: {
              id: bookId
            }
          };

          if (hasBridalKey) {
            itemData.attributes.bridal = 'bridal';
          }

          fetch("/cart/add.js", {
            method: "POST",
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify(itemData)
          }).then(res => res.json())
            .then(data => {
              console.log('=== CART ADD RESPONSE ===');
              console.log('Cart add response:', data);
              return fetch('/cart.js');
            })
            .then(response => response.json())
            .then(cartData => {
              console.log('=== CART CONTENT ===');
              console.log('Cart attributes:', cartData.attributes);
              console.log('Cart items:', cartData.items);

              ga('ec:setAction', 'add');
              ga('send', 'event', 'UX', 'click', 'add to cart');
              window.location.href = `${process.env.REACT_APP_SHOPIFY_ADDR}/cart`;
              this.setState({ submitting: false });
            })
            .catch(error => {
              console.error('Cart add error:', error);
              this.setState({ submitting: false });
            });
        }
      })
      .catch(error => {
        console.error("Error: " + error);
        this.setState({ submitting: false });
        alert("只今アクセスが集中しております。\n少し時間をおいてから再度お試しいただけますようお願いいたします。");
      });
  };

  render() {
    const { order, isInCart, artistName, isOrderedDigital, variants } = this.props;
    const { isConfirm, submitting } = this.state;
    const { id, ...data } = getSnapshot(order.book);
    const productType = productTypeMap[order.book.productType];

    //子から親への息子か娘か
    const child = artistName === "aoyama" ? "daughter" : "son";

    const infoBorderColor = {
      borderLeftColor: ""
    };

    // infoTextの色設定
    // TODO: ここの判定は今後商品が増えると変更が必要かも
    if (productType === "parent_to_child") {
      infoBorderColor.borderLeftColor = order.book.artistName === "nakagawa" ? "#62c1b4" : "#cc7eb2";
    } else if (productType === "child_to_parent") {
      infoBorderColor.borderLeftColor = order.book.artistName === "aoyama" ? "#DC9660" : "#409ad6";
    } else if (productType === "female_to_male") {
      infoBorderColor.borderLeftColor = "#ec6d65";
    }

    // 各step情報
    const stepDataList = {
      // 男性から女性へのシカケテガミ
      male_to_female: {
        step1: {
          infoText: "シカケテガミを作成するための基本情報として、あなたとシカケテガミをプレゼントする相手のことを少しだけ教えてください。",
          image: "step1.jpg",
          imageBridal: `step1_M2F_${artistName}_bridal.jpg`,
          content: <Information book={order.book} order={order} />
        },
        step2: {
          infoText: "シカケテガミに登場する主人公（あなたとプレゼントする相手）の顔を、オリジナルでつくりましょう。",
          image: "step2.jpg",
          content: <FaceSelection book={order.book} artistName={artistName} order={order} />
        },
        step3: {
          infoText: "全21の選択文の中から、お２人が最も共感できるストーリーを５つ選びましょう（選んだストーリーは1-5の順に製本されますので順番にご注意ください）。",
          image: "step3.jpg",
          content: <StorySelection artistName={artistName} book={order.book} order={order} setpImage={"step3.jpg"} />
        },
        step4: {
          infoText: "シカケテガミの最終ページにはあなたのオリジナルメッセージが印刷されます。いつもはなかなか面と向かって伝えられないキモチを、ぜひ文章に込めてあげてください。きっと喜んでもらえますよ！",
          image: "step4.jpg",
          imageBridal: `step4_M2F_${artistName}_bridal.jpg`,
          content: <CustomMessage book={order.book} order={order} />
        },
        step5: {
          title: "推薦人/推薦文の選択",
          infoText: "あなたがつくったシカケテガミを、２人の共通の友人や家族等から推薦してもらいましょう。",
          image: "step5.jpg",
          imageBridal: `step5_M2F_${artistName}_bridal.jpg`,
          content: <Panflet book={order.book} order={order} setpImage={"step5.jpg"} />
        }
      },
      // 親から子へのシカケテガミ
      parent_to_child: {
        step1: {
          infoText: "シカケテガミを作成するための基本情報として、あなたとシカケテガミをプレゼントするお子様のことを少しだけ教えてください。",
          image: "step1_parent_to_child.jpg",
          content: <InformationParentToChild book={order.book} order={order} />
        },
        step2: {
          infoText: "シカケテガミに登場する主人公の顔を、オリジナルでつくりましょう。",
          image: "step2_parent_to_child.jpg",
          content: <FaceSelectionParentToChild book={order.book} artistName={artistName} order={order} />
        },
        step3: {
          infoText: "これまでお子様から教えられたこと、気づかされたこと、助けられたことがきっとたくさんあると思います。次の中から、あなたとお子様にとって最も印象深いストーリーを5つお選びください（選んだストーリーは1-5の順に製本されますので順番にご注意ください）。",
          image: "step3_parent_to_child.jpg",
          content: <StorySelectionParentToChild artistName={artistName} book={order.book} order={order} setpImage={"step3_parent_to_child.jpg"} />
        },
        step4: {
          infoText: "シカケテガミの最終ページには、あなたからのオリジナルメッセージが印刷されます。年頃になった未来のお子様に向けて、ぜひあなたのキモチを残してあげてください。きっといつかお子様のチカラになるはずです！",
          image: "step4_parent_to_child.jpg",
          slide: "step4_parent_to_child2.jpg",
          notice: "※こちらのメッセージは隠しシールで封印してお届けします",
          content: <CustomMessageParentToChild book={order.book} order={order} />
        },
        step5: {
          title: "帯デザインの選択",
          infoText: "最後に、あなたがつくったシカケテガミの帯テキストデザインを選びましょう。",
          image: "step5_parent_to_child.jpg",
          content: <PanfletParentToChild book={order.book} order={order} setpImage={"step5_parent_to_child.jpg"} />
        }
      },
      // 女性から男性へのシカケテガミ
      female_to_male: {
        step1: {
          infoText: "シカケテガミを作成するための基本情報として、あなたとシカケテガミをプレゼントする相手のことを少しだけ教えてください。",
          image: "step1_female_to_male.jpg",
          imageBridal: `step1_F2M_${artistName}_bridal.jpg`,
          content: <InformationFemaleToMale book={order.book} order={order} />
        },
        step2: {
          infoText: "シカケテガミに登場する主人公（あなたとプレゼントする相手）の顔を、オリジナルでつくりましょう。",
          image: "step2.jpg",
          content: <FaceSelectionFemaleToMale book={order.book} artistName={artistName} order={order} />
        },
        step3: {
          infoText: "複数ある選択文の中から、お２人が最も共感できるストーリーを５つ選びましょう（選んだストーリーはA-Eの順に製本されますので順番にご注意ください）。",
          content: <StorySelectionFemaleToMale artistName={artistName} book={order.book} order={order} setpImage={"step3_female_to_male.jpg"} />
        },
        step4: {
          infoText: "シカケテガミの最終ページにはあなたのオリジナルメッセージが印刷されます。いつもはなかなか面と向かって伝えられないキモチを、ぜひ文章に込めてあげてください。きっと喜んでもらえますよ！",
          image: "step4_female_to_male.jpg",
          imageBridal: `step4_F2M_${artistName}_bridal.jpg`,
          content: <CustomMessageFemaleToMale book={order.book} order={order} />
        },
        step5: {
          title: "推薦人/推薦文の選択",
          infoText: "あなたがつくったシカケテガミを、２人の共通の友人や家族等から推薦してもらいましょう。",
          imageBridal: `step5_F2M_${artistName}_bridal.jpg`,
          content: <PanfletFemaleToMale book={order.book} order={order} setpImage={"step5_female_to_male.jpg"} />
        }
      },
      // 子から親へのシカケテガミ
      child_to_parent: {
        step1: {
          infoText: "シカケテガミを作成するための基本情報として、あなたとシカケテガミをプレゼントする親御さんのことを少しだけ教えてください。",
          image: `step1_child_to_parent_${child}.jpg`,
          imageBridal: `step1_C2P_${artistName}_bridal.jpg`,
          content: <InformationChildToParent book={order.book} order={order} />
        },
        step2: {
          infoText: "シカケテガミに登場する主人公の顔を、オリジナルでつくりましょう。",
          image: `step2_child_to_parent_${child}.jpg`,
          content: <FaceSelectionChildToParent book={order.book} artistName={artistName} order={order} />
        },
        step3: {
          infoText: "これまでちゃんと言葉にして伝えられなかった「ありがとう」がきっとたくさんあると思います。次の中から、あなたと親御さんにとって最も印象深いストーリーをお選びください（選んだストーリーは番号順に製本されますので順番にご注意ください）。",
          image: `step3_child_to_parent_${child}.jpg`,
          content: <StorySelectionChildToParent artistName={artistName} book={order.book} order={order} setpImage={`step3_child_to_parent_${child}.jpg`} />
        },
        step4: {
          infoText: "シカケテガミの最終ページには、あなたからのオリジナルメッセージが印刷されます。いつもはなかなか面と向かって伝えられないキモチを、ぜひ文章に込めてあげてください。きっと喜んでもらえますよ！",
          image: `step4_child_to_parent_${child}.jpg`,
          imageBridal: `step4_C2P_${artistName}_bridal.jpg`,
          content: <CustomMessageChildToParent book={order.book} order={order} />
        },
        step5: {
          title: "推薦人/推薦文の選択",
          infoText: "最後に、あなたがつくったシカケテガミの帯テキストデザインを選びましょう！",
          image: `step5_child_to_parent_${child}.jpg`,
          imageBridal: `step5_C2P_${artistName}_bridal.jpg`,
          content: <PanfletChildToParent book={order.book} order={order} setpImage={`step5_child_to_parent_${child}.jpg`} />
        }
      },
    };
    const { step1, step2, step3, step4, step5 } = stepDataList[productType];

    let currentStep = "";
    let bookId = id;
    let storyCount = '５';

    // productTypeが増えると分岐も増える
    if (productType === "parent_to_child") {
      // 親から子へのシカケテガミ
      currentStep = order.currentStepParentToChild;
      bookId = data.parentToChild.id;
    } else if (productType === "child_to_parent") {
      // 子から親へのシカケテガミ
      currentStep = order.currentStepChildToParent;
      bookId = data.childToParent.id;
      // 両親宛て もしくは 父 or 母宛て でストーリーの数が違う
      const receiverForParents = data.productType === "child_to_parents";
      const childToParentStoryCount = receiverForParents
        ? '６' : '４';
      storyCount = childToParentStoryCount;
      if (!receiverForParents && data.childToParent.stories.length === 6) {
        // bookから2つ削除
        order.book.childToParent.removeStoriesLastTwo();
      }
    } else if (productType === "female_to_male") {
      // 女性から男性へのシカケテガミ
      currentStep = order.currentStepFemaleToMale;
    } else {
      // 男性から女性へのシカケテガミ
      currentStep = order.currentStep;
    }



    const hasBridalKey =
      data.bridal &&
      typeof data.bridal === "object" &&
      data.bridal.key &&
      data.bridal.key.trim() !== "";

    const getBridalImagePrefix = () => {
      if (productType === "male_to_female") {
        return artistName === "nakagawa" ? "toBride1" : "toBride2";
      } else if (productType === "female_to_male") {
        return "toGroom";
      } else if (productType === "child_to_parent" || productType === "child_to_parents") {
        const isGroom = artistName === "okuta";
        const isParents = data.productType === "child_to_parents";
        if (isGroom) {
          return isParents ? "fromGroomToParents" : "fromGroomToParent";
        } else {
          return isParents ? "fromBrideToParents" : "fromBrideToParent";
        }
      }
      return null;
    };

    const bridalImagePrefix = getBridalImagePrefix();

    let hasDad = false;
    let hasMom = false;

    if (productType === "child_to_parent" && data.childToParent) {
      hasDad = data.childToParent.dadName && data.childToParent.dadName.trim();
      hasMom = data.childToParent.momName && data.childToParent.momName.trim();
    }

    const formAction = hasBridalKey ? `${process.env.REACT_APP_BRIDAL_API_ADDR}/book/${bookId}/` : `${process.env.REACT_APP_API_ADDR}/book/${bookId}/`;
    // 既存のhasBridalKey定義の直後に、画像選択用のヘルパー関数を追加
    const getStepImage = (step) => {
      if (hasBridalKey && step.imageBridal) {
        return step.imageBridal;
      }
      return step.image;
    };

    // hasBridalKeyの定義の後に、step5のcontentを条件分岐
    const getStep5Content = () => {
      if (!hasBridalKey) {
        return step5.content;
      }

      const bridalImageMap = {
        male_to_female: `step5_M2F_${artistName}_bridal.jpg`,
        female_to_male: `step5_F2M_${artistName}_bridal.jpg`,
        child_to_parent: `step5_C2P_${artistName}_bridal.jpg`,
        parent_to_child: step5.image // parent_to_childはbridalの出し分けなし
      };

      const bridalImage = bridalImageMap[productType];

      // 各productTypeに対応するコンポーネントを返す
      switch (productType) {
        case "male_to_female":
          return <Panflet book={order.book} order={order} setpImage={bridalImage} />;
        case "female_to_male":
          return <PanfletFemaleToMale book={order.book} order={order} setpImage={bridalImage} />;
        case "child_to_parent":
          return <PanfletChildToParent book={order.book} order={order} setpImage={bridalImage} />;
        case "parent_to_child":
          return <PanfletParentToChild book={order.book} order={order} setpImage={step5.image} />;
        default:
          return step5.content;
      }
    };

    const step5Content = getStep5Content();

    return (
      <div className="order">
        <div style={{
          "display": submitting ? "block" : "none", // or "none"
          "opacity": 0.7,
          "position": "fixed",
          "width": "100%",
          "minHeight": "100%",
          "top": 0,
          "left": 0,
          "backgroundColor": "#000000",
          "zIndex": 99998
        }}>
          <img
            style={{
              "position": "absolute",
              "top": "0px",
              "bottom": "0px",
              "left": "0px",
              "right": "0px",
              "zIndex": 99999,
              "margin": "auto",
            }}
            src="https://cdn.shopify.com/s/files/1/0012/2568/7076/files/icon_loader_a_bb_01_s1.gif?340"
          />
        </div>
        <Collapse
          accordion
          activeKey={currentStep === "-" ? "-" : currentStep}
          bordered={false}
          onChange={evt => order.changeCurrentStep(evt)}
        >
          <Panel
            className={`${order.canShowCustom ? "bg-grey" : ""}`}
            header={
              <Row>
                <Col span={21}>
                  <Title lbl="基本情報の入力" step="1" validated={true} />
                </Col>
                <Col span={3}>
                  <i
                    className="arrow"
                    style={{ top: "13px", lineHeight: "0px" }}
                  />
                </Col>
              </Row>
            }
            key="info"
            showArrow={false}
          >
            <div
              className="info"
              style={infoBorderColor}
              dangerouslySetInnerHTML={{ __html: step1.infoText }}
            ></div>
            <img
              style={{
                padding: "16px 15px 0px",
                width: "100%",
                height: "auto"
              }}
              src={require(`../imgs/${getStepImage(step1)}`)}
            />
            {step1.content}
          </Panel>
          <Panel
            className={`custom${order.canShowStories ? " bg-grey" : ""}`}
            disabled={!order.canShowCustom}
            header={
              <Row>
                <Col span={21}>
                  <Title
                    lbl="主人公の顔の選択"
                    validated={order.canShowCustom}
                  />
                </Col>
                <Col span={3}>
                  <i
                    className="arrow"
                    style={{ top: "13px", lineHeight: "0px" }}
                  />
                </Col>
              </Row>
            }
            key="custom"
            showArrow={false}
          >
            <div
              className="info"
              style={infoBorderColor}
              dangerouslySetInnerHTML={{ __html: step2.infoText }}
            ></div>
            <img
              style={{
                padding: "16px 15px 0px",
                width: "100%",
                height: "auto"
              }}
              src={require(`../imgs/${step2.image}`)}
            />
            {step2.content}
          </Panel>
          <Panel
            className={`${order.canShowMessage ? "bg-grey" : ""}`}
            disabled={!order.canShowStories}
            header={
              <Row>
                <Col span={21}>
                  <Title
                    lbl={`選択文（${storyCount}つ）の選択`}
                    validated={order.canShowStories}
                  />
                </Col>
                <Col span={3}>
                  <i
                    className="arrow"
                    style={{ top: "13px", lineHeight: "0px" }}
                  />
                </Col>
              </Row>
            }
            key="stories"
            showArrow={false}
          >
            <div
              className="info"
              style={infoBorderColor}
              dangerouslySetInnerHTML={{ __html: step3.infoText }}
            ></div>
            {step3.content}
          </Panel>
          <Panel
            className={`${order.canShowPanflet ? "bg-grey" : ""}`}
            disabled={!order.canShowMessage}
            header={
              <Row>
                <Col span={21}>
                  <Title
                    lbl="自由メッセージの入力"
                    validated={order.canShowMessage}
                  />
                </Col>
                <Col span={3}>
                  <i
                    className="arrow"
                    style={{ top: "13px", lineHeight: "0px" }}
                  />
                </Col>
              </Row>
            }
            key="message"
            showArrow={false}
          >
            <div
              className="info"
              style={infoBorderColor}
              dangerouslySetInnerHTML={{ __html: step4.infoText }}
            ></div>
            {step4.slide
              ? <div style={{ position: "relative" }}>
                <img
                  style={{
                    height: "auto",
                    padding: "24px 15px 0px",
                    position: "absolute",
                    top: "0",
                    left: "0",
                    width: "100%"
                  }}
                  className="fadeInOut"
                  src={require(`../imgs/${step4.slide}`)}
                />
                <img
                  style={{
                    height: "auto",
                    padding: "24px 15px 0px",
                    width: "100%"
                  }}
                  src={require(`../imgs/${getStepImage(step4)}`)}
                />
              </div>
              : <img
                style={{
                  padding: "24px 15px 0px",
                  width: "100%",
                  height: "auto"
                }}
                src={require(`../imgs/${getStepImage(step4)}`)}
              />
            }
            {step4.notice && <p style={{ fontWeight: "bold", paddingLeft: "15px" }}>{step4.notice}</p>}
            {step4.content}
          </Panel>
          <Panel
            className={`${order.canShowPreview ? "bg-grey" : ""}`}
            disabled={!order.canShowPanflet}
            header={
              <Row>
                <Col span={21}>
                  <Title
                    lbl={step5.title}
                    validated={order.canShowPanflet}
                  />
                </Col>
                <Col span={3}>
                  <i
                    className="arrow"
                    style={{ top: "13px", lineHeight: "0px" }}
                  />
                </Col>
              </Row>
            }
            key="panflet"
            showArrow={false}
          >
            <div
              className="info"
              style={infoBorderColor}
              dangerouslySetInnerHTML={{ __html: step5.infoText }}
            ></div>
            {step5Content}
          </Panel>
        </Collapse>
        {order.canShowPreview ? (
          <div className="pd-15 notice_massage">
            <form
              id="invisible_form"
              action={formAction}
              method="post"
              target="_blank"
            >
              {parseBook(data)}
              <div className="btn-wrap">
                <button type="submit" className="btn">
                  内容を確認する
                  <img
                    src="https://cdn.shopify.com/s/files/1/0012/2568/7076/files/arrow-right.png?11461796108671507714"
                    className="btn-arrow"
                  />
                </button>
              </div>
            </form>
            <br />

            {/* bridalデータがある場合に画像を表示 */}
            {hasBridalKey && bridalImagePrefix && (
              <div
                style={{ textAlign: "center", marginTop: "16px", marginBottom: "16px", paddingBottom: "16px", borderBottom: "1px solid #ccc" }}
                className={`bridal-img`}>
                <p className="bridal-text">＜表紙の衣装はこちら＞</p>
                {bridalImagePrefix === "fromGroomToParents" && (
                  <img
                    src={require(`../imgs/fromGroomToParents-${data.bridal.style}-${data.bridal.groomColor}.jpg`)}
                    alt=""
                  />
                )}
                {bridalImagePrefix === "fromBrideToParents" && (
                  <img
                    src={require(`../imgs/fromBrideToParents-${data.bridal.style}-${data.bridal.brideColor}.jpg`)}
                    alt=""
                  />
                )}
                {bridalImagePrefix === "fromGroomToParent" && (
                  <div>
                    {hasDad && (
                      <img
                        src={require(
                          `../imgs/fromGroomToFather-${data.bridal.style}-${data.bridal.groomColor}.jpg`
                        )}
                        alt=""
                      />
                    )}

                    {hasMom && (
                      <img
                        src={require(
                          `../imgs/fromGroomToMother-${data.bridal.style}-${data.bridal.groomColor}.jpg`
                        )}
                        alt=""
                      />
                    )}
                  </div>
                )}
                {bridalImagePrefix === "fromBrideToParent" && (
                  <div>
                    {hasDad && (
                      <img
                        src={require(
                          `../imgs/fromBrideToFather-${data.bridal.style}-${data.bridal.brideColor}.jpg`
                        )}
                        alt=""
                      />
                    )}

                    {hasMom && (
                      <img
                        src={require(
                          `../imgs/fromBrideToMother-${data.bridal.style}-${data.bridal.brideColor}.jpg`
                        )}
                        alt=""
                      />
                    )}
                  </div>
                )}
                {(bridalImagePrefix !== "fromGroomToParents" &&
                  bridalImagePrefix !== "fromBrideToParents" &&
                  bridalImagePrefix !== "fromGroomToParent" &&
                  bridalImagePrefix !== "fromBrideToParent") && (
                    <img
                      src={require(`../imgs/${bridalImagePrefix}-${data.bridal.style}-${data.bridal.brideColor}-${data.bridal.groomColor}.jpg`)}
                      alt=""
                    />
                  )}
                <p className="bridal-note">※顔やお名前はサンプルとなります。</p>
              </div>
            )}
            <div style={{ textAlign: "center" }}>
              <Checkbox onChange={this.handleConfirmChange} checked={isConfirm}>内容に誤りがないことを確認しました。</Checkbox>
            </div>

            <form onSubmit={this.handleSubmit}>
              <input type="hidden" name="attributes[id]" value={bookId} />
              {/* bridalフラグを追加 */}
              {(() => {
                const hasBridalKey = data.bridal && data.bridal.key && data.bridal.key !== "";
                return hasBridalKey ? (
                  <input type="hidden" name="attributes[bridal]" value="true" />
                ) : null;
              })()}
              {Variants(variants)}
              <div className="product-form__item product-form__item--submit">
                <div className="btn-wrap">
                  <button
                    className="btn product-btn product-form__cart-submit"
                    htmltype="submit"
                    name="add"
                    disabled={!(isConfirm == true && submitting == false)} // isConfirm=true, this.state.submitting=false のときのみ disabled=false
                  >
                    {isInCart ? "保存とカートへ" : "カートへ進む"}
                    <img
                      src="https://cdn.shopify.com/s/files/1/0012/2568/7076/files/arrow-right-purple.png?13701503969354364487"
                      className="btn-arrow"
                    />
                  </button>
                </div>
              </div>
            </form>
          </div>
        ) : null}
      </div>
    );
  }
}

export default observer(Order);



// WEBPACK FOOTER //
// ./src/views/Order.js